import React from 'react';
import cls from './AuthButtons.module.css';

type Props = {
  onLogin: () => void;
  onSignUp: () => void;
};

export const AuthButtons: React.FC<Props> = ({ onLogin, onSignUp }) => {
  return (
    <>
      {/* ---------- Login ---------- */}
      <div
        onClick={onLogin}
        style={{
          position: 'absolute',
          width: 259.84,
          height: 52.48,
          left: 1048.08,
          top: 51.76,
          background: 'rgba(99, 48, 193, 0.3)',
          backgroundBlendMode: 'plus-lighter',
          mixBlendMode: 'normal',
          boxShadow: `-7.13626px -6.65088px 30.72px -7.68px rgba(0,0,0,0.15),
            -1.18938px -1.10848px 7.68px -5.12px rgba(0,0,0,0.15),
            inset 1.18938px 1.10848px 5.12px rgba(255,255,255,0.15),
            inset 0.594688px 0.55424px 2.56px rgba(255,255,255,0.15)`,
          backdropFilter: 'blur(1.28px)',
          borderRadius: 26.24,
          cursor: 'pointer',
          transition: 'transform .2s',
          zIndex: 10,
        }}
        onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(.96)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <span
          style={{
            position: 'absolute',
            width: 103.04,
            height: 35.84,
            left: 16,
            top: 8.32,
            fontFamily: `'SF Pro', sans-serif`,
            fontStyle: 'normal',
            fontWeight: 510,
            fontSize: 30.72,
            lineHeight: '37px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
          }}
        >
          Login
        </span>
      </div>

      {/* ---------- Sign Up ---------- */}
      <div
        onClick={onSignUp}
        style={{
          position: 'absolute',
          width: 138.24,
          height: 52.48,
          left: 1169.68,
          top: 51.76,
          background: 'rgba(99, 48, 193, 0.8)',
          backgroundBlendMode: 'plus-lighter',
          mixBlendMode: 'normal',
          boxShadow: `-7.13626px -6.65088px 30.72px -7.68px rgba(0,0,0,0.15),
            -1.18938px -1.10848px 7.68px -5.12px rgba(0,0,0,0.15),
            inset 1.18938px 1.10848px 5.12px rgba(255,255,255,0.15),
            inset 0.594688px 0.55424px 2.56px rgba(255,255,255,0.15)`,
          backdropFilter: 'blur(1.28px)',
          borderRadius: 26.24,
          cursor: 'pointer',
          transition: 'transform .2s',
          zIndex: 200,
        }}
        onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(.96)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <span
          style={{
            position: 'absolute',
            width: 119.68,
            height: 35.84,
            left: 11.52,
            top: 8.32,
            fontFamily: `'SF Pro', sans-serif`,
            fontStyle: 'normal',
            fontWeight: 510,
            fontSize: 30.72,
            lineHeight: '37px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            borderRadius: 26.24,
          }}
          className={cls.login}
        >
          Sign Up
        </span>
      </div>
    </>
  );
};